// ---------------------- Toggle desktop filters ----------------------
function toggleFilters() {
  const sidebar = document.getElementById('filterSidebar');
  const toggleText = document.getElementById('filterToggleText');

  sidebar.classList.toggle('desktop');
  toggleText.textContent = sidebar.classList.contains('desktop') ? 'Hide Filters' : 'Filter';
}

// ---------------------- Sidebar controls ----------------------
function initSidebarControls() {

  // Dropdown toggle
  document.addEventListener('click', function (e) {
    const header = e.target.closest('.filter-header');
    if (!header) return;

    const options = header.nextElementSibling;
    const arrow = header.querySelector('.arrow');
    if (!options) return;

    options.classList.toggle('is-closed');
    if (arrow) arrow.classList.toggle('rotate', !options.classList.contains('is-closed'));
  });

  // Search inside sidebar
  document.querySelectorAll('.search-input').forEach(input => {
    let timer;

    input.addEventListener('input', function () {
      clearTimeout(timer);

      timer = setTimeout(() => {
        const filter = input.value.toUpperCase().trim();
        const container = input.closest('.filter-options, div[id$="Filters"]');
        if (!container) return;

        const labels = container.querySelectorAll('label');
        const toggleBtn = container.querySelector('.toggle-filter-btn');

        if (filter) {
          labels.forEach(label => {
            label.classList.remove('is-hidden');
            label.style.display =
              label.textContent.toUpperCase().includes(filter) ? 'flex' : 'none';
          });
          if (toggleBtn) toggleBtn.style.display = 'none';
        } else {
          labels.forEach((label, i) => {
            label.style.display = 'flex';
            label.classList.toggle('is-hidden', i >= 3);
          });
          if (toggleBtn) toggleBtn.style.display = 'block';
        }
      }, 150);
    });
  });

  // Show more / less buttons
  document.querySelectorAll('.toggle-filter-btn').forEach(button => {
    button.addEventListener('click', function () {
      const filterId = this.dataset.filterId;
      const limit = parseInt(this.dataset.limit) || 3;
      const expanded = this.dataset.expanded === 'true';
      const filters = document.querySelectorAll(`#${filterId} .custom_search_filter`);

      filters.forEach((el, index) => {
        if (index >= limit) {
          el.classList.toggle('is-hidden', expanded);
        }
      });

      this.dataset.expanded = (!expanded).toString();
      this.setAttribute('aria-expanded', (!expanded).toString());
      this.textContent = expanded ? 'Show More' : 'Show Less';
    });
  });
}

// ---------------------- Filter Summary Bar ----------------------
function updateSelectedFilters() {
  const summaryBar = document.getElementById('filter-summary');
  if (!summaryBar) return;

  summaryBar.textContent = '';
  const checked = document.querySelectorAll('.filter-checkbox:checked');
  if (!checked.length) return;

  const fragment = document.createDocumentFragment();

  checked.forEach(cb => {
    const tag = document.createElement('span');
    tag.className = 'filter-tag';
    tag.textContent = cb.value;

    const removeBtn = document.createElement('button');
    removeBtn.className = 'remove-tag';
    removeBtn.innerHTML = '&times;';
    removeBtn.onclick = () => {
      cb.checked = false;
      cb.dispatchEvent(new Event('change'));
    };

    tag.appendChild(removeBtn);
    fragment.appendChild(tag);
  });

  if (checked.length > 1) {
    const clear = document.createElement('button');
    clear.className = 'clear-all-btn';
    clear.textContent = 'Clear All';
    clear.onclick = () => {
      checked.forEach(cb => {
        cb.checked = false;
        cb.dispatchEvent(new Event('change'));
      });
    };
    fragment.appendChild(clear);
  }

  summaryBar.appendChild(fragment);
}

// ---------------------- Mobile drawer close ----------------------
function closeMobileFilter() {
  document.getElementById('mobileFilterDrawers')?.classList.remove('open');
}

// ---------------------- Build Collection Card ----------------------
function buildCollectionGridItem(c) {
  const gridItem = document.createElement('div');

  gridItem.className = 'grid__item';
  gridItem.setAttribute('data-carousel-slide', '');
  gridItem.setAttribute('data-item', '');
  gridItem.setAttribute('data-title', c.title || '');
  gridItem.setAttribute('data-state', c.state || '');
  gridItem.setAttribute('data-city', c.city || '');
  gridItem.setAttribute('data-str-styles', c.styles || '');
  gridItem.setAttribute('data-str-category', c.categories || '');

  const img600 = c.image || '';
  const img300 = img600.replace(/width=600/g, 'width=300');

  gridItem.innerHTML = `
    <div class="collection-grid-item section--image text--white" data-grid-slide>
      <a href="${c.url}" class="collection-card" aria-label="${c.title}">
        <span class="sr-only">${c.title}</span>

        <div class="card-media">
          <img
            src="${img600}"
            srcset="
              ${img300} 360w,
              ${img300} 480w,
              ${img600} 600w
            "
            sizes="(max-width: 767px) 100vw, 600px"
            alt="${c.title}"
            loading="lazy"
            width="600"
            height="400"
          >
          <div class="card-overlay"></div>
        </div>

        <div class="card-top">
          ${c.products} Products
        </div>

        <p class="collection-grid-item__title accent-size-3 strong card-middle">
          ${c.title}
        </p>

        <div class="card-bottom">
          View Collection
        </div>
      </a>
    </div>
  `;

  // IMPORTANT: hide initially (same as filter logic expects)
  gridItem.classList.add('hidden');

  return gridItem;
}


// ---------------------- Filter + Load More (UNCHANGED) ----------------------
function initFiltersAndLoadMore() {
  const stateCheckboxes = document.querySelectorAll('.state-filter');
  const cityCheckboxes = document.querySelectorAll('.city-filter');
  const categoryCheckboxes = document.querySelectorAll('.category-filter');
  const styleDesignCheckboxes = document.querySelectorAll('.style-design-filter');
  const loadMoreBtn = document.getElementById('loadMoreBtn');

  const items = Array.from(document.querySelectorAll('.grid__item'));

  const initialVisibleCount = 8;
  const itemsPerClick = 8;
  let filteredItems = [];
  let visibleCount = initialVisibleCount;

  items.forEach(item => {
    item._state = item.dataset.state || '';
    item._city = item.dataset.city || '';
    item._styles = (item.dataset.strStyles || '').split(',').map(s => s.trim());
    item._categories = (item.dataset.strCategory || '').split(',').map(s => s.trim());
  });

  function getCheckedValues(cbs) {
    return [...cbs].filter(cb => cb.checked).map(cb => cb.value.trim());
  }

  function updateCityVisibility() {
    const states = getCheckedValues(stateCheckboxes);
    cityCheckboxes.forEach(cb => {
      const visible = !states.length || states.includes(cb.dataset.cityState);
      cb.parentElement.style.display = visible ? 'flex' : 'none';
      cb.disabled = !visible;
      if (!visible) cb.checked = false;
    });
  }

  function combinedFilter() {
    const s = getCheckedValues(stateCheckboxes);
    const c = getCheckedValues(cityCheckboxes);
    const cat = getCheckedValues(categoryCheckboxes);
    const st = getCheckedValues(styleDesignCheckboxes);

    filteredItems = [];
    visibleCount = initialVisibleCount;

    items.forEach(item => {
      const match =
        (!s.length || s.includes(item._state)) &&
        (!c.length || c.includes(item._city)) &&
        (!cat.length || cat.some(v => item._styles.includes(v))) &&
        (!st.length || st.some(v => item._categories.includes(v)));

      item.classList.add('hidden');
      if (match) filteredItems.push(item);
    });

    filteredItems.forEach((item, i) => {
      item.classList.toggle('hidden', i >= initialVisibleCount);
    });

    loadMoreBtn.style.display =
      filteredItems.length > initialVisibleCount ? 'block' : 'none';
  }

  function loadMoreItems() {
    const next = visibleCount + itemsPerClick;
    for (let i = visibleCount; i < next && i < filteredItems.length; i++) {
      filteredItems[i].classList.remove('hidden');
    }
    visibleCount = next;
    if (visibleCount >= filteredItems.length) loadMoreBtn.style.display = 'none';
  }

  [...stateCheckboxes, ...cityCheckboxes, ...categoryCheckboxes, ...styleDesignCheckboxes]
    .forEach(cb => cb.addEventListener('change', () => {
      updateCityVisibility();
      combinedFilter();
      updateSelectedFilters();
    }));

  loadMoreBtn.addEventListener('click', loadMoreItems);

  updateCityVisibility();
  combinedFilter();
  updateSelectedFilters();
}

// ---------------------- Main ----------------------
document.addEventListener('DOMContentLoaded', function () {
  const grid = document.getElementById('gridContainer');
  const jsonEl = document.getElementById('remaining-collections-data');

  if (grid && jsonEl) {
    const data = JSON.parse(jsonEl.textContent || '[]');
    let index = 0;

    function insert() {
      const frag = document.createDocumentFragment();
      for (let i = 0; i < 25 && index < data.length; i++, index++) {
        frag.appendChild(buildCollectionGridItem(data[index]));
      }
      grid.appendChild(frag);
      if (index < data.length) requestAnimationFrame(insert);
      else {
        initFiltersAndLoadMore();
        initSidebarControls();
      }
    }
    insert();
  } else {
    initFiltersAndLoadMore();
    initSidebarControls();
  }
});
